import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashbord.jsx";
const Router = () => {
    const isAdmin = localStorage.getItem("isAdmin") === "true";

    return (
        <Routes>

            {/* Redirection */}
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Login */}
            <Route path="/login" element={<Login />} />


            {/* Pages admin protégées */}
            <Route
                path="/dashbord"
                element={isAdmin ? <Dashboard /> : <Navigate to="/login" />}
            />


        </Routes>
    );
};

export default Router;
